<a href="#" class="back u-mb40 toggle" data-id="tab-one-c">
  Vigencia de documentos
</a>

<div class="u-bt u-bt--grey">
  <div class="row">
    <div class="col-md-3 u-pt30 u-pb10">
      <h3 class="txt txt--section">
        Minera Escondida
      </h3>
      <p class="txt txt--paragraph">
        Nº: 12345567
      </p>
    </div>
    <div class="col-md-9 u-right u-pt30 u-pb20">
      <div class="innermenu">
        <ul>
          <li>
            <a href="">Renovar licencia</a>
          </li>
          <li>
            <a href="">Ampliar licencia</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="u-bt u-bt--grey u-pt20">
  <div class="row">
    <div class="col-md-3">
      <h4 class="txt txt--paragraph u-mb10">
        <strong>
          Restricciones de conducción:
        </strong>
      </h4>
      <p class="txt txt--small txt--grey">
        El conductor debe ir con lentes durante la conducción. Lorem ipsum alter netsus
      </p>
    </div>
  </div>
</div>

<div class="task u-mb20 u-mt20">
  <div class="task__table">
    <div class="task__tr">
      <div class="task__td task__td--model">
        <div class="task__number">
          1
        </div>
        <div class="task__label">
          Carga - camión articulado
        </div>
        <div class="task__text">
          Camión de remolque
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--zone">
          Zonas registradas:
        </div>
        <div class="task__text">
          <ul>
            <li>
              Zonas remotas
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--type">
          Tipo de licencia
        </div>
        <div class="task__text">
          Conducción y operación
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--license">
          Licencia municipal
        </div>
        <div class="task__text">
          <ul>
            <li>
              B
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--end">
          Vencimiento
        </div>
        <div class="task__text">
          08/04/2021
        </div>
      </div>
    </div>
  </div>
</div>
<div class="task u-mb20 u-mt20">
  <div class="task__table">
    <div class="task__tr">
      <div class="task__td task__td--model">
        <div class="task__number">
          2
        </div>
        <div class="task__label">
          Carga - camión articulado
        </div>
        <div class="task__text">
          Camión de remolque
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--zone">
          Zonas registradas:
        </div>
        <div class="task__text">
          <ul>
            <li>
              Zonas remotas
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--type">
          Tipo de licencia
        </div>
        <div class="task__text">
          Conducción y operación
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--license">
          Licencia municipal
        </div>
        <div class="task__text">
          <ul>
            <li>
              B
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--end">
          Vencimiento
        </div>
        <div class="task__text">
          08/04/2021
        </div>
      </div>
    </div>
  </div>
</div>
<div class="task u-mb20 u-mt20">
  <div class="task__table">
    <div class="task__tr">
      <div class="task__td task__td--model">
        <div class="task__number">
          3
        </div>
        <div class="task__label">
          Carga - camión articulado
        </div>
        <div class="task__text">
          Camión de remolque
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--zone">
          Zonas registradas:
        </div>
        <div class="task__text">
          <ul>
            <li>
              Zonas remotas
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--type">
          Tipo de licencia
        </div>
        <div class="task__text">
          Conducción y operación
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--license">
          Licencia municipal
        </div>
        <div class="task__text">
          <ul>
            <li>
              B
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td">
        <div class="task__label task__label--icon task__label--end">
          Vencimiento
        </div>
        <div class="task__text">
          08/04/2021
        </div>
      </div>
    </div>
  </div>
</div>

<div class="table table--documents u-mb20 u-bt">
  <div class="thead thead--border">
    <div class="tr">
      <div class="th">Nombre documento</div>
      <div class="th">Documento</div>
      <div class="th">Fecha de vigencia</div>
    </div>
  </div>
  <div class="tbody">
    <div class="tr">
      <div class="td td--name td--pt">
        <p>Examen Psicosensotécnico</p>
        <span class="bhptooltip" data-text="Ejemplo de prueba"></span>
      </div>
      <div class="td td--pt td--doc td--hide">
        <a class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0"> <img
            src="../../dist/img/link.png" alt=""> Ver documento</a>
      </div>
      <div class="td td--pt td--date td--hide">
        <p>Del 11/08/2020 al 11/03/2021</p>
      </div>
    </div>
    <div class="tr">
      <div class="td td--name td--pt">
        <p>Hoja de vida</p>
        <span class="bhptooltip" data-text="Ejemplo de prueba"></span>
        <h6 class="txt txt--paragraph">*Máximo 3 meses de antiguedad</h6>
      </div>
      <div class="td td--pt td--doc td--hide">
        <a class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0"> <img
            src="../../dist/img/link.png" alt=""> Ver documento</a>
      </div>
      <div class="td td--pt td--date td--hide">
        <p>Emisión el 11/08/2020</p>
      </div>
    </div>
    <div class="tr">
      <div class="td td--name td--pt">
        <p>Fotocopia Licencia Municipal (B o C)</p>
        <span class="bhptooltip" data-text="Ejemplo de prueba"></span>
        <h6 class="txt txt--paragraph">O bien licencia Internacional de Conducción </h6>
      </div>
      <div class="td td--pt td--doc td--hide">
        <a class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0"> <img
            src="../../dist/img/link.png" alt=""> Ver documento</a>
      </div>
      <div class="td td--pt td--date td--hide">
        <p>Del 11/08/2020 al 11/03/2021</p>
      </div>
    </div>
    <div class="tr">
      <div class="td td--name td--pt">
        <p>Entrenamiento “Manejo defensivo”</p>
        <span class="bhptooltip" data-text="Ejemplo de prueba"></span>
      </div>
      <div class="td td--pt td--doc td--hide">
        <a class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0"> <img
            src="../../dist/img/link.png" alt=""> Ver documento</a>
      </div>
      <div class="td td--pt td--date td--hide">
        <p>Del 11/08/2020 al 11/03/2021</p>
      </div>
    </div>
  </div>
</div>
